export const CREATE_BREAKDOWN_FLOW_TEXT = {
	modalTitle: 'Breakdown the work assignment',
	common: {
		dateTimeLabel: 'Date and time of incident',
		timeAriaLabel: 'Time of incident',
		timezoneNoteLabel: 'Note:',
		timezoneNote:
			'the time zone for the incident will be determined based on the breakdown location or segment',
		segmentLabel: 'Segment of incident',
		segmentPlaceholder: 'Select a segment',
		segmentTimeSubtitle: (from, to) => `Segment time: ${from} → ${to}`,
		segmentAutocompleteListLabel: 'Segments',
		segmentAutocompleteResetLabel: 'Clear',
		locationLabel: 'Breakdown location',
		locationPlaceholder: 'Select a location',
		reasonLabel: 'Reason',
		reasonPlaceholder: 'Select a reason',
		absenceStartLabel: 'Original driver absence start',
		absenceTimeAriaLabel: 'Absence start time',
		absenceReasonLabel: 'Absence reason',
		absenceReasonPlaceholder: 'Select',
		parallelRideCheckboxLabel: 'utilize parallel ride for passenger pickup',
		addNoteLink: 'Add a note',
		noteLabel: 'Note (optional)',
	},
	subtitles: {
		common: 'Please specify the date, time, location of the incident, and the reason for it.',
		parallelRide: 'Specify the parallel ride',
		parallelRideWithCushion:
			'Specify the parallel ride and the original driver cushioning parameters',
		busDeadhead: 'Choose Deadhead and specify the primary parameters',
		fatigueReplacement: 'Select the replacement driver and post incident driving start time',
		driverOutOfHoursReplacement:
			'Select the replacement driver and post incident driving start time',
	},
	deadhead: {
		label: 'Deadhead',
		placeholder: 'Select a deadhead',
		loading: 'Loading deadheads…',
		error: (message) => `Couldn't load deadheads (${message}). Try again later.`,
		empty: 'No available deadheads within 12 hours of the incident time.',
		useMockedResults: 'Use mocked results',
	},
	parallelRide: {
		label: 'Ride',
		placeholder: 'Search by trip number',
		loading: 'Loading rides…',
		error: (message) => `Couldn't load rides (${message}). Try again later.`,
		empty: 'No rides available right now.',
	},
	cushioning: {
		driverLabel: 'Cushioning driver',
		driverPlaceholder: 'Select a driver',
		driverPrefix: 'Cushioning driver:',
		fallbackDriverName: 'Original driver',
		startsLabel: 'Cushioning start',
		endsLabel: 'Cushioning end',
		startsTimeAriaLabel: 'Cushioning start time',
		endsTimeAriaLabel: 'Cushioning end time',
	},
	postIncidentDriving: {
		dateLabel: 'Post incident driving start date and time',
		timeAriaLabel: 'Post-incident driving start time',
	},
	replacementEtdEta: {
		etdLabel: 'Replacement ETD',
		etdTimeAriaLabel: 'Replacement ETD time',
		etaLabel: 'Replacement ETA',
		etaTimeAriaLabel: 'Replacement ETA time',
	},
	originalDriverCushioning: {
		sectionLabel: 'Original driver cushioning parameters:',
		startsLabel: 'Travelling start',
		endsLabel: 'Travelling end',
		startsTimeAriaLabel: 'Travelling start time',
		endsTimeAriaLabel: 'Travelling end time',
	},
	summary: {
		heading: 'Review the breakdown',
		sectionTitles: {
			common: 'Common',
			deadheadInfo: 'Deadhead info',
			replacementDriverInfo: 'Replacement driver info',
			postIncidentDriving: 'Post-incident driving',
			cushioningParameters: 'Cushioning parameters',
			parallelRide: 'Parallel ride',
		},
		rowLabels: {
			breakdownReason: 'Breakdown reason',
			incidentTime: 'Incident time',
			segment: 'Segment',
			breakdownLocation: 'Breakdown location',
			originalDriverAbsenceStart: 'Original driver absence start',
			note: 'Note',
			route: 'Route',
			schedule: 'Schedule',
			type: 'Type',
			departureLocation: 'Departure location',
			replacementDriverName: 'Replacement driver name',
			replacementDriverId: 'Replacement driver ID',
			replacementEtd: 'Replacement ETD',
			replacementEta: 'Replacement ETA',
			driverName: 'Driver name',
			driverId: 'Driver ID',
			cushioningStart: 'Cushioning start',
			cushioningEnd: 'Cushioning end',
			tripLine: 'Trip number/Line number',
			departure: 'Departure',
			start: 'Start',
		},
		originalDriverAnnotation: '(original driver)',
	},
	errors: {
		absenceBeforeIncident: 'Absence start cannot be before the incident time.',
		cushionEndBeforeStart: 'Cushioning end cannot be before the cushioning start.',
		cushionStartBeforeIncident: 'Cushioning start cannot be before the incident time.',
		etaBeforeEtd: 'ETA must be after ETD.',
		etdBeforeIncident: 'Replacement ETD cannot be before the incident time.',
		drivingBeforeIncident: 'Driving start cannot be before the incident time.',
		drivingBeforeEta: 'Post-incident driving cannot start before the replacement arrival (ETA).',
	},
	breakdownLocation: {
		xStationLabel: 'X station',
		autocompleteLabel: 'Breakdown location',
		autocompletePlaceholder: 'Select or type to search',
		autocompleteListLabel: 'Breakdown stations',
		autocompleteResetLabel: 'Clear',
		groupSegment: 'Incident segment stations',
		groupApproximate: 'Approximate location',
	},
};
